import { ViewObjectSettings } from "../view-object-settings";

export class TableSettings extends ViewObjectSettings {
  constructor(settings) {
    super(settings);
    this.rows = [];
    for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
      let rowSettings = settings.rows[rowIndex];
      this.rows.push({
        height: rowSettings.height?.copy()
      });
    }
    this.columns = [];
    for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
      let columnSettings = settings.columns[columnIndex];
      this.columns.push({
        width: columnSettings.width?.copy()
      });
    }
    this.rowsSpace = settings.rowsSpace?.copy(); // type: CalculatedDimension
    this.columnsSpace = settings.columnsSpace?.copy(); // type: CalculatedDimension
    this.mergedCells = [];
    for (let cellIndex = 0; cellIndex < settings.mergedCells.length; cellIndex++) {
      let mergedCellInfo = settings.mergedCells[cellIndex];
      this.mergedCells.push({
        rowBegin: mergedCellInfo.rowBegin,
        rowEnd: mergedCellInfo.rowEnd,
        columnBegin: mergedCellInfo.columnBegin,
        columnEnd: mergedCellInfo.columnEnd
      });
    }
    this.items = [];
    for (let rowIndex = 0; rowIndex < settings.items.length; rowIndex++) {
      let rowItems = settings.items[rowIndex];
      let rowItemsCopies = [];
      for (let columnIndex = 0; columnIndex < rowItems.length; columnIndex++) {
        rowItemsCopies.push(rowItems[columnIndex]?.copy()); // type: ViewObjectSettings
      }
      this.items.push(rowItemsCopies);
    }
  }

  copy() {
    return new TableSettings(this);
  }
}
